'use client';
export { default } from './components/become-partners-section/become-partners-section';
